import { makeStyles } from '@mui/styles';

const useReportStyle = makeStyles(() => ({
  container: {
    padding: '30px 30px 30px 260px',
  },
}));

export default useReportStyle;
